var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonecall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.719,
    height: 16.749,
    viewBox: "0 0 16.719 16.749",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#4a4b4d;stroke-linecap:round;stroke-linejoin:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.871,4.5a3.75,3.75,0,0,1,2.963,2.963M12.871,1.5a6.75,6.75,0,0,1,5.963,5.955m-.75,5.985v2.25a1.5,1.5,0,0,1-1.635,1.5,14.842,14.842,0,0,1-6.473-2.3,14.625,14.625,0,0,1-4.5-4.5,14.842,14.842,0,0,1-2.3-6.5A1.5,1.5,0,0,1,4.666,2.25h2.25a1.5,1.5,0,0,1,1.5,1.29,9.63,9.63,0,0,0,.525,2.108A1.5,1.5,0,0,1,8.6,7.23l-.953.952a12,12,0,0,0,4.5,4.5l.952-.953a1.5,1.5,0,0,1,1.583-.337,9.63,9.63,0,0,0,2.108.525A1.5,1.5,0,0,1,18.084,13.44Z",
    transform: "translate(-2.667 -0.948)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonecall);
export default __webpack_public_path__ + "static/media/phonecall.db2eed94d11920d91dd6fcc9448649d1.svg";
export { ForwardRef as ReactComponent };